import React from "react";
import { ShuffleListLoaderTemplate } from "themes/administration/shuffle/components";

function ShuffleListLoader(props) {
    return <ShuffleListLoaderTemplate {...props} />;
}

export default ShuffleListLoader;
